import { render, staticRenderFns } from "./HistoryChangesView.vue?vue&type=template&id=207e3395&scoped=true"
import script from "./HistoryChangesView.vue?vue&type=script&lang=js"
export * from "./HistoryChangesView.vue?vue&type=script&lang=js"
import style0 from "./HistoryChangesView.vue?vue&type=style&index=0&id=207e3395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207e3395",
  null
  
)

export default component.exports